/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
// import BASEURL from "../config";
const BASEURL = process.env.BASEURL;

function isSecure() {
    // this will determine whether we save cookie in secure mode or not
    if (process.env.NODE_ENV === "production" && window.location.protocol === "https:") {
        return "secure;";
    }
    return "";
}

function getDomain() {
    return ";domain=" + window.location.hostname.substring(window.location.hostname.indexOf("."));
}

function getDomainPrefix(notAppendHappay) {
    let domainPrefix = window.location.hostname.substring(window.location.hostname.indexOf(".") + 1);
    domainPrefix = domainPrefix.substring(0, domainPrefix.lastIndexOf("."));
    if (notAppendHappay) {
        domainPrefix = domainPrefix.replace("happay", "");
        if (domainPrefix.indexOf(".") === domainPrefix.length - 1) {
            domainPrefix = domainPrefix.replace(".", "");
        }
    }
    return domainPrefix;
}

function _setCookie(key, value, notAppendHappay = false) {
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${getDomainPrefix(
        notAppendHappay
    )}.${key}=${value};${expires}${getDomain()};path=/;${isSecure()}`;
}

function _setSSOLoginInfo(domain) {
    const loginInfo = {
        loginType: "sso",
        loginValue: domain
    };
    _setCookie("loginInfo", JSON.stringify(loginInfo), true);
}

function _getCookieValue(key) {
    const name = `happay.${key}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            const value = c.substring(name.length, c.length);
            return value;
        }
    }

    return "";
}

function getSafeRedirectFromHash(hash) {
    if (!hash || hash.indexOf("#") !== 0) {
        return null;
    }

    let target;
    try {
        target = decodeURIComponent(hash.substring(1)).trim();
    } catch (err) {
        return null;
    }

    if (!target) {
        return null;
    }

    const lower = target.toLowerCase();
    if (
        /^(https?:|\/\/|javascript:|data:|vbscript:)/i.test(lower) ||
        target.indexOf("\\") !== -1 ||
        lower.indexOf("://") !== -1
    ) {
        return null;
    }

    try {
        const resolved = new URL(target, window.location.origin);
        if (resolved.origin !== window.location.origin) {
            return null;
        }
        return resolved.pathname + resolved.search + resolved.hash;
    } catch (err) {
        return null;
    }
}

function handleLocationHash() {
    const hashRedirect = getSafeRedirectFromHash(window.location.hash);
    if (hashRedirect) {
        window.location = hashRedirect;
        return true;
    }
    if (window.location.hash.length > 1) {
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        return true;
    }
    return false;
}

const hostName = window.location.hostname;
let subDomain = hostName.split(".")[0];
if (hostName.includes("hdfcbank.poweredby")) {
    // This logic is for HDFC poweredby
    subDomain = hostName.substring(0, hostName.indexOf(".happay.in"));
}

window.addEventListener("hashchange", handleLocationHash);

if (!handleLocationHash()) {
    const { pathname } = window.location;
    const queryKey = window.location.search;
    const nonSSO = [
        "local",
        "dev",
        "v2",
        "expense",
        "vendor",
        "localhost",
        "travel",
        "v2-uat",
        "expense-uat",
        "v2-prep",
        "expense-prep",
        "dev-icici-prep-crd",
        "v2-new-ui",
        "segfault1",
        "v2-nui-prep",
        "hdfcbank",
        "uat-hdfcbank",
        "myclaims",
        "myexpense"
    ];

    if (
        subDomain &&
        nonSSO.indexOf(subDomain) === -1 &&
        queryKey.indexOf("logout") === -1 &&
        !pathname.includes("/login/verifyemail/") &&
        !_getCookieValue("cid")
    ) {
        debugger;
        const url = `${BASEURL}access/v2/sso/?domain=${subDomain}`;
        var http = new XMLHttpRequest();
        http.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                // eslint-disable-next-line no-debugger
                const urls = unescape(decodeURIComponent(pathname + queryKey)); // decodeURIComponent(window.location.hash);
                const urlArr = urls ? urls.split("?") : [];

                // filtering the hash key generated due to history
                const queryArr =
                    (urlArr[1] && urlArr[1].split("&").filter(q => !q.startsWith("_"))) || [];

                if (queryArr && queryArr.length && urlArr[1].indexOf("c_code") === -1) {
                    queryArr.splice(queryArr.length, 0, "c_code=+91");
                }

                if (queryArr && queryArr.length && urlArr[1].indexOf("hasRole") === -1) {
                    queryArr.splice(queryArr.length, 0, "hasRole=false");
                }

                const urlObj = {};
                const initialPartOfURL = urlArr[0];
                // var queryPartOfURL = queryArr.join("&");

                if (queryKey.indexOf("user") !== -1 && queryKey.indexOf("userId") !== -1) {
                    for (const key in queryArr) {
                        const tempArray = queryArr[key].split("=");
                        const name = tempArray[0];
                        let value = tempArray[1];

                        if (name === "c_code" && !value) {
                            value = "+91";
                        }
                        if (!urlObj.hasOwnProperty(name)) {
                            urlObj[name] = {};
                        }
                        urlObj[name] = value;
                    }
                }

                if (urlArr && urlArr.length) {
                    const redirectUrl = initialPartOfURL + queryKey;
                    localStorage.setItem("isSSO", true);
                    if (redirectUrl !== "/" && redirectUrl !== "/login") {
                        localStorage.setItem("redirectUrl", redirectUrl);
                        if (urlObj.hasOwnProperty("user") && urlObj.hasOwnProperty("userId")) {
                            localStorage.setItem("urlObj", JSON.stringify(urlObj));
                        }
                    }
                }

                let dt = { redirect_url: "" };
                try {
                    dt = JSON.parse(this.response);
                } catch (err) {
                    console.log(err);
                }
                if (dt.redirect_url) {
                    _setSSOLoginInfo(subDomain);
                    window.location = dt.redirect_url;
                }
            } else if (this.readyState === 4 && this.status > 399) {
                try {
                    const dt = JSON.parse(this.response);
                    console.log(dt);
                } catch (err) {
                    console.log(err);
                }
            }
        };
        http.open("GET", url, true);
        http.send();
    }
}
